export default {
  notification: {
    success: {
      token: 'Código de acesso novo gerado com sucesso.',
      enableSharing: 'A funcionalidade de compartilhamento do dashboard foi habilitada com sucesso.',
    },
  },
  label: {
    title: {
      published: 'Compartilhamento',
      publishedBy: 'Publicado por:',
      publishedAt: 'Publicado em:',
      token: 'Código de acesso',
      hiddenComponents: 'Componentes ocultados',
      description: {
        token: 'Ao gerar um código novo, os usuários que acessam este dashboard com o código atual perderão o acesso.',
        dashboardHidden: 'Este dashboard tem componentes com informações sensíveis que não devem ser acessadas por usuários convidados. Ao prosseguir com o compartilhamento, esses componentes serão automaticamente ocultados. Para saber mais, acesse nossa Central de Ajuda e consulte nossa Política de Compartilhamento.',
        dashboardHiddenCentralLink: ' Central de Ajuda',
        dashboardHiddenAux: ' e consulte nossa',
        dashboardHiddenPolicyLink: ' Politica de Compartilhamento.',
      },
    },
    panel: {
      components: 'Componentes',
    },
    tooltip: {
      notPermitted: 'Você precisar estar logado para alterar as opções de publicação.',
      notPublished: 'Dashboard não publicado, ao publicar o mesmo estará visivel a qualquer pessoa.',
      published: 'Dashboard publicado.',
      publishedBy: 'Publicado por:',
    },
    pagination: 'Mostrando {page} - {size} de {count}',
    switch: 'Dashboard compartilhado',
    url: 'URL de acesso',
    token: 'Código de acesso',
    button: {
      regenerateToken: 'Gerar novo código de acesso',
      remove: 'Excluir componentes',
    },
  },
};
